// extracted by mini-css-extract-plugin
export default {"container":"Checkbox2_container__6S7bX","label":"Checkbox2_label__fwRIt","input":"Checkbox2_input__2Gbsz","box":"Checkbox2_box__9C3tQ","text":"Checkbox2_text__HJJmD"};